import customAxios from "../serverCall";

const uploadFile = async (file) => {
  const formData = new FormData();
  formData.append('files', file);
  
  const response = await customAxios.post(`/admin/upload`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      'user-agent': 'Dart/3.5 (dart:io)',
      'accept-encoding': 'gzip',
    },
  });
  return response;
};

const UploadService = {
  uploadFile,
};

export default UploadService; 